<template>
  <div class="page-block vip-page">
    <h2>会员中心</h2>

    <section v-if="isLogin" class="vip-status card">
      <h3 v-if="false">当前状态</h3>
      <p v-if="vip.active" class="status-on">
        <strong>{{ vip.planTitle || "会员" }}</strong>
        <span class="tag">{{ planTypeLabel(vip.planType) }}</span>
      </p>
      <p v-else class="muted">暂无生效中的会员权益</p>
      <ul class="meta-list">
        <li v-if="vip.active && vip.planType !== 'times'">
          <span>到期时间</span>
          <span>{{ formatTs(vip.expireAt) }}</span>
        </li>
        <li v-if="vip.active && vip.planType === 'times'">
          <span>剩余次数</span>
          <span>{{ vip.timesRemaining }} 次</span>
        </li>
        <li v-if="vip.active">
          <span>创作折扣</span>
          <span>{{ discountLabel(vip.discountPercent) }}</span>
        </li>
        <li v-if="vip.active && vip.rightsText">
          <span>权益说明</span>
          <span class="rights">{{ vip.rightsText }}</span>
        </li>
      </ul>
    </section>

    <section v-else class="hint card muted">
      登录后可查看会员状态并购买套餐。
    </section>

    <h3 class="section-title">可购套餐</h3>
    <p v-if="!plans.length" class="muted">
      当前没有开放购买的套餐（后台将「参考价(元)」设为大于 0 后展示）。
    </p>
    <div class="plan-grid">
      <div v-for="p in plans" :key="p.id" class="plan-card card">
        <div class="plan-head">
          <span class="plan-title">{{ p.title || "套餐" }}</span>
          <span class="tag">{{ planTypeLabel(p.planType) }}</span>
        </div>
        <ul class="plan-meta">
          <li><span>创作折扣</span><span>{{ discountLabel(p.discountPercent) }}</span></li>
          <li v-if="p.planType !== 'times'">
            <span>时长</span><span>{{ p.durationDays }} 天</span>
          </li>
          <li v-else>
            <span>次数</span><span>每次购买 +{{ p.timesQuota }} 次</span>
          </li>
          <li>
            <span>售价</span><span>¥{{ formatYuan(p.priceYuan) }}</span>
          </li>
          <li v-if="p.bonusPoints > 0">
            <span>购买赠送</span><span>{{ p.bonusPoints }} 积分</span>
          </li>
        </ul>
        <p v-if="p.rightsText" class="rights-block">{{ p.rightsText }}</p>
        <div class="plan-foot">
          <span class="price">¥{{ formatYuan(p.priceYuan) }}</span>
          <button
            type="button"
            class="buy-btn"
            :disabled="!isLogin || payingId === p.id"
            @click="openPayPicker(p)"
          >
            {{ payingId === p.id ? "处理中…" : "立即购买" }}
          </button>
        </div>
      </div>
    </div>

    <pay-method-picker
      :visible="payPickerVisible"
      :subtitle="payPickerSubtitle"
      @close="closePayPicker"
      @confirm="confirmVipPay"
    />
  </div>
</template>

<script>
import { userApi } from "../api/user";
import PayMethodPicker from "../components/PayMethodPicker.vue";
import { openCashPayWindow } from "../utils/cashPayOpenUrl";

const emptyVip = () => ({
  active: false,
  planId: 0,
  planTitle: "",
  planType: "",
  expireAt: 0,
  timesRemaining: 0,
  discountPercent: 100,
  rightsText: ""
});

export default {
  name: "VipPage",
  components: { PayMethodPicker },
  data() {
    return {
      plans: [],
      vip: emptyVip(),
      isLogin: false,
      payingId: 0,
      payPickerVisible: false,
      selectedPlan: null
    };
  },
  computed: {
    payPickerSubtitle() {
      if (!this.selectedPlan) return "";
      const name = this.selectedPlan.title || "会员套餐";
      return `${name} / ¥${this.formatYuan(this.selectedPlan.priceYuan)}`;
    }
  },
  async created() {
    await this.loadPlans();
    await this.loadProfile();
  },
  methods: {
    formatYuan(v) {
      const n = Number(v);
      if (Number.isNaN(n)) return "—";
      if (Number.isInteger(n)) return String(n);
      return n.toFixed(2);
    },
    planTypeLabel(t) {
      const m = { times: "次卡", month: "月卡", quarter: "季卡", year: "年卡" };
      return m[t] || t || "--";
    },
    discountLabel(pct) {
      const n = Number(pct);
      if (!n || n >= 100) return "无折扣（原价）";
      return `${n / 10} 折`;
    },
    formatTs(ts) {
      const n = Number(ts);
      if (!n) return "--";
      try {
        return new Date(n * 1000).toLocaleString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit"
        });
      } catch (e) {
        return "--";
      }
    },
    async loadPlans() {
      try {
        const data = await userApi.vipPlans();
        this.plans = Array.isArray(data && data.plans) ? data.plans : [];
      } catch (e) {
        this.plans = [];
      }
    },
    async loadProfile() {
      const token = localStorage.getItem("user_token");
      if (!token) {
        this.isLogin = false;
        this.vip = emptyVip();
        return;
      }
      try {
        const profile = await userApi.profile();
        this.isLogin = true;
        const v = profile.vip && typeof profile.vip === "object" ? profile.vip : {};
        this.vip = Object.assign(emptyVip(), v);
      } catch (e) {
        this.isLogin = false;
        this.vip = emptyVip();
      }
    },
    openPayPicker(p) {
      if (!this.isLogin) {
        this.$root.$emit("open-login");
        return;
      }
      this.selectedPlan = p;
      this.payPickerVisible = true;
    },
    closePayPicker() {
      this.payPickerVisible = false;
      this.selectedPlan = null;
    },
    async pollPaid(outTradeNo, maxRounds = 24, intervalMs = 2500) {
      if (!outTradeNo) return false;
      for (let i = 0; i < maxRounds; i += 1) {
        try {
          const order = await userApi.queryRechargeOrder({ outTradeNo });
          if (order && order.status === "paid") {
            return true;
          }
          if (order && (order.status === "failed" || order.status === "closed")) {
            return false;
          }
        } catch (e) {
          // ignore
        }
        await new Promise(r => setTimeout(r, intervalMs));
      }
      return false;
    },
    async confirmVipPay({ payType }) {
      const p = this.selectedPlan;
      this.closePayPicker();
      if (!p || !p.id) return;
      if (!this.isLogin) {
        this.$root.$emit("open-login");
        return;
      }
      this.payingId = p.id;
      try {
        const res = await userApi.buyVipPlanPay({
          vipPlanId: p.id,
          payType: payType || "wechat"
        });
        const opened = openCashPayWindow(res && res.payPayload, payType || "wechat");
        if (opened) {
          window.alert("订单已创建，请在新窗口完成支付。正在确认到账…");
          const paid = await this.pollPaid(res.outTradeNo);
          if (paid) {
            await this.loadProfile();
            this.$root.$emit("points-changed");
            window.alert("支付成功，会员权益已生效。");
          } else {
            await this.loadProfile();
          }
        } else {
          const prov = res && res.payPayload && res.payPayload.provider;
          window.alert(
            prov && prov !== "mock"
              ? "订单已创建，但未生成支付链接。请在后台「系统配置 → AI接口配置」勾选所选支付方式并填全密钥后重新下单。"
              : "订单已创建，当前为模拟支付模式：请在后台勾选微信/支付宝并保存；联调可用 mock 回调完成到账。"
          );
        }
      } catch (e) {
        window.alert(e && e.message ? e.message : "下单失败");
      } finally {
        this.payingId = 0;
      }
    }
  }
};
</script>

<style scoped>
.vip-page {
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}

.vip-page .section-title {
  margin-top: 1.5rem;
  font-size: 1.1rem;
}
.card {
  background: #2a2a2a;
  border-radius: 10px;
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid #3a3a3a;
}
.muted {
  color: #9a9a9a;
}
.status-on {
  margin: 0.25rem 0 0.75rem;
}
.tag {
  display: inline-block;
  margin-left: 0.5rem;
  padding: 0.1rem 0.45rem;
  font-size: 14px;
  border-radius: 4px;
  background: #444;
  color: #e8e0c8;
}
.meta-list,
.plan-meta {
  list-style: none;
  padding: 0;
  margin: 0;
}
.meta-list li,
.plan-meta li {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 3px 0;
  border-top: 1px solid #333;
  font-size: 14px;
}
.meta-list li:first-child,
.plan-meta li:first-child {
  border-top: none;
}
.meta-list span:first-child,
.plan-meta span:first-child {
  color: #9a9a9a;
}
.rights {
  text-align: right;
  max-width: 70%;
}
.plan-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 1rem;
}
.plan-card {
  display: flex;
  flex-direction: column;
}
.plan-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.plan-title {
  font-weight: 600;
}
.rights-block {
  font-size: 13px;
  color: #b8b8b8;
  margin: 0.5rem 0 0;
  line-height: 1.45;
}
.plan-foot {
  margin-top: auto;
  padding-top: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}
.price {
  color: #f0d090;
  font-weight: 600;
}
.buy-btn {
  padding: 0.4rem 0.9rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  background: linear-gradient(135deg, #c9a227, #8a6d1a);
  color: #1a1a1a;
  font-weight: 600;
}
.buy-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .plan-grid {
    grid-template-columns: 1fr;
  }

  .rights {
    max-width: 100%;
    text-align: left;
  }

  .meta-list li,
  .plan-meta li {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .plan-head {
    flex-wrap: wrap;
    gap: 8px;
  }

  .plan-foot {
    flex-direction: column;
    align-items: stretch;
  }

  .buy-btn {
    width: 100%;
  }
}
</style>
